import Navbar from '@/pages/home/components/Navbar';
import Services from '@/pages/home/components/Services';
import TenantScreening from '@/pages/home/components/TenantScreening';
import LeaseManagement from '@/pages/home/components/LeaseManagement';
import MaintenanceCoordination from '@/pages/home/components/MaintenanceCoordination';
import Footer from '@/pages/home/components/Footer';
import PageHero from '@/components/feature/PageHero';
import PageTransition from '@/components/feature/PageTransition';
import PageCrossLink from '@/components/feature/PageCrossLink';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const servicesSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Premium Property Management Services',
  provider: {
    '@type': 'RealEstateAgent',
    name: 'Higher Standard Global',
    url: siteUrl,
  },
  url: `${siteUrl}/services`,
  description:
    'A comprehensive suite of property management disciplines — tenant screening, lease management, and maintenance coordination — each executed with an exacting standard.',
  serviceType: 'Property Management',
  areaServed: 'Worldwide',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Property Management Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Tenant Screening' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Lease Management' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Maintenance Coordination' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Long-Term Rental Management' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Short-Term Rental Management' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Vacation Property Management' } },
    ],
  },
};

export default function ServicesPage() {
  useSEO({
    title: 'Property Management Services | Higher Standard Global',
    description:
      'Comprehensive property management services including tenant screening, lease management, and maintenance coordination. Higher Standard Global serves select clientele by referral only.',
    keywords: 'property management services, tenant screening, lease management, maintenance coordination, vacation rental management, short-term rental management',
    canonical: '/services',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={servicesSchema} id="schema-services" />
      <Navbar />
      <PageHero
        eyebrow="What We Do"
        title="Our Services"
        subtitle="A comprehensive suite of property management disciplines — each executed with the same exacting standard we apply to every engagement."
        imageUrl="https://public.readdy.ai/ai/img_res/cf946be698d6b1026c211a88e3d01182.jpg"
        ctaLabel="Get in Touch"
        ctaPath="/contact"
      />
      <PageTransition label="Our Disciplines" />
      <Services />
      <TenantScreening />
      <LeaseManagement />
      <MaintenanceCoordination />
      <PageCrossLink
        prev={{
          label: 'Philosophy',
          eyebrow: 'Our Guiding Principles',
          description: 'The values and long-view thinking behind every decision we make.',
          path: '/philosophy',
        }}
        next={{
          label: 'Property Types',
          eyebrow: 'Portfolio',
          description: 'See the range of exceptional properties we are equipped to manage.',
          path: '/properties',
        }}
      />
      <Footer />
    </main>
  );
}
